import { useProcessIdOnTier0Page } from "components/MeritTier0Page/tier0Utils";
import {
  useGetPageFromPath,
  useProcessesInVisibleGroups,
  useVisibleProcessIds,
  useDetailKey,
  useFilteredProcessIds,
} from "utils/customHooks/genericHooks";

/** use filterByLeaderAndContstraints = false for DDAs-by-process (timeline column, process tile metrics) */
export function useProcessIdsForDataDumpFullRange(
  filterByLeaderAndContstraints = true
) {
  const {
    isGroupTilesPage,
    isHubletPage,
    isTrendsPage,
    isOperatorPage,
    isGridLayoutPage,
    isProcessTilesPage,
    isTimelinePage,
    isTier0Page,
  } = useGetPageFromPath();
  const processIdTier0Page = useProcessIdOnTier0Page();
  const processesInVisibleGroups = useProcessesInVisibleGroups();
  const detailKey = useDetailKey();
  const processIdForSingleProcessPage = processesInVisibleGroups[detailKey]?.id;

  const filteredProcessIds = useFilteredProcessIds(
    filterByLeaderAndContstraints
  );

  const visibleProcessesIds = useVisibleProcessIds();
  const detailsPageProcessId = isHubletPage && visibleProcessesIds?.[0];

  const gridLayoutPageProcesses = processIdForSingleProcessPage
    ? [processIdForSingleProcessPage] // process id for details page
    : filteredProcessIds;

  let result;
  if (isTier0Page) {
    result = [processIdTier0Page];
  } else if (
    isGroupTilesPage ||
    isProcessTilesPage ||
    isTimelinePage ||
    isTrendsPage
  ) {
    result = filteredProcessIds;
  } else if (isGridLayoutPage) {
    result = gridLayoutPageProcesses;
  } else if (isOperatorPage) {
    result = [processIdForSingleProcessPage];
  } else if (detailsPageProcessId) {
    result = [detailsPageProcessId];
  } else {
    result = filteredProcessIds;
  }

  return result.filter(Boolean);
}
